<template>
	<div class="background-home bg-secondary-900 absolute top-0 left-0 w-full inset-0 -z-10 overflow-hidden">
		<div class="absolute -bottom-40 -left-10 max-w-7xl w-full">
			<div class="relative w-full h-[576px]">
				<div class="circle-blur blur-[150px] rounded-full absolute bottom-0 left-0 w-full inset-0 scale-100" />
			</div>
		</div>

		<div class="absolute -top-80 sm:-top-1/4 -right-40 smm:-right-28 sm:right-0">
			<div class="relative w-[576px] h-[576px]">
				<div
					class="circle-blur blur-[150px] sm:blur-[220px] rounded-full absolute smm:top-1/4 -right-20 smm:right-0 w-full h-full scale-100"
				/>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
defineOptions({
	name: 'BackgroundHomeSectionExclusive',
})
</script>

<style lang="postcss">
.background-home {
	.circle-blur {
		@apply opacity-30 bg-[#1EC34C];
	}
}
</style>
